// src/components/WhatsAppButton.js
import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import './whatsapp.css'

const WhatsAppButton = () => {
  // Número de telefone e mensagem padrão
  const phoneNumber = '5511969953700'; // Substitua pelo seu número
  const message = 'Olá, gostaria de solicitar um orçamento!';
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button-fix"
      initial={{ scale: 1 }}
      animate={{ 
        scale: [1, 1.05, 1],
        boxShadow: ['0 4px 8px rgba(0,0,0,0.2)', '0 6px 12px rgba(37, 211, 102, 0.4)', '0 4px 8px rgba(0,0,0,0.2)']
      }}
      transition={{ 
        repeat: Infinity, 
        duration: 2,
        ease: "easeInOut"
      }}
      whileHover={{ scale: 1.1 }}
    >
      <FaWhatsapp className="whatsapp-icon-fix" />
      <span>Solicitar Orçamento</span>
    </motion.a>
  );
};

export default WhatsAppButton;